module.exports = __webpack_public_path__ + "img/order_logo.128e4ed4.png";